import styled, { css } from 'styled-components';

export const IconTextWrapper = styled.div`
  text-align: center;
`;

export const IconWrapper = styled.div`
  ${({ theme }) =>
    theme.tasks &&
    css`
      margin: 13px auto 16px;
    `}
`;
